/**
 * Role levels are the fundamental value attached to users that define their admin permissions.
 * Here we create an object that defines all role levels, which are accessible by
 * their human readable property names.
 */
export const roleLevels = {
  planet_admin: 2000,
  planet_user: 1999,
  org_admin: 1000,
  org_user: 100,
};

export const isAdmin = user => {
  if (!user) {
    return false;
  }

  return user.role_level > roleLevels.org_user;
};

export const isPlanetAdmin = user => {
  if (!user) {
    return false;
  }

  return user.role_level >= roleLevels.planet_user;
};

export const isUsersOrg = (userClaims, orgId) => {
  return !orgId || orgId === userClaims?.organization_id;
};
